import React, { useEffect } from 'react'
import { fetchSubtrees } from '../../../state/actions/customer'
import { useAuth0 } from '@auth0/auth0-react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { TeamDetails } from './teamDetails'
import FleetUsers from './fleetUsers'
import FleetVehicles from './fleetVehicles/fleetVehicles'
import { EmptyState } from './emptyState'

export const Teams = ({ orgSubPages }) => {

  const { getAccessTokenSilently } = useAuth0()
  const { domainId, option } = useParams()
  const navigate = useNavigate()
  const total = useSelector(s => s.subtrees.totalChildren)
  
  const location = useLocation()

  const skipFetch = location.state?.skipFetch

  const children = orgSubPages
    .filter(row => !row.disabled)
    .map(team => ({ ...team }))
  
  const dispatch = useDispatch()
  useEffect(() => {
    getAccessTokenSilently()
      .then(token => {
        dispatch(fetchSubtrees( token ))
      })
  }, [])

  useEffect(() => {
    if (!(option === 'fleet_teams' && (!domainId))) {
      return
    }
    if (total > 0 && children?.length > 0) {
      navigate(children[0].id)
    }
  }, [total, children?.length])
  

  if (['fleet_users', 'fleet_vehicles'].includes(option)) return

  if (option === 'fleet_teams' && (!domainId)) {
    if (!total) {
      return <EmptyState title='No team created' textRow='Nothing here yet.' textRow2=' Create your team/s in the left side panel to build up your organisation.'/> 
    }
  } 
  if (domainId?.startsWith('all-users-')) {
    const orgId = domainId.replace('all-users-', '')
    return <FleetUsers orgId={orgId} />
  }
  if (domainId?.startsWith('all-vehicles-')) {
    const orgId = domainId.replace('all-vehicles-', '')
    return <FleetVehicles orgId={orgId}  />
  }
  if (domainId) {
    return <TeamDetails uuid={domainId} skipFetch={skipFetch} />
  }}


